import { useState } from "react";
import api, { apiErr } from "@/lib/api";
import { DateInput } from "@/components/DateInput";
import { useI18n } from "@/context/I18nContext";
import { fl } from "@/lib/finI18n";
import { JournalLines, blankLine, journalTotals, linesPayload } from "@/components/JournalLines";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

const blank = () => ({ date: new Date().toISOString().slice(0, 10), description: "", reference: "", lines: [blankLine("dr"), blankLine("cr")] });

export function JournalInline({ clientId, coa, onSaved, onCancel }) {
  const { t, lang } = useI18n();
  const [f, setF] = useState(blank);
  const [postNow, setPostNow] = useState(true);
  const [saving, setSaving] = useState(false);
  const { balanced } = journalTotals(f.lines);

  const save = async () => {
    setSaving(true);
    try {
      const payload = { client_id: clientId, date: f.date, description: f.description, reference: f.reference, lines: linesPayload(f.lines) };
      const { data } = await api.post("/journal-entries", payload);
      if (postNow) await api.post(`/journal-entries/${data.id}/post`);
      toast.success(postNow ? "Jurnal disimpan & diposting" : "Jurnal disimpan sebagai draft");
      setF(blank());
      if (onSaved) onSaved();
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); } finally { setSaving(false); }
  };

  return (
    <div className="sm:col-span-2 min-w-0 space-y-3" data-testid="txn-journal-inline">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div className="space-y-1.5"><Label>{t("common.date")}</Label><DateInput value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })} data-testid="txn-journal-date" /></div>
        <div className="sm:col-span-2 space-y-1.5"><Label>{t("common.description")}</Label><Input value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} placeholder={t("jf.descPlaceholder")} data-testid="txn-journal-desc" /></div>
      </div>
      <div className="space-y-1.5"><Label>{t("jf.referenceOpt")}</Label><Input value={f.reference} onChange={(e) => setF({ ...f, reference: e.target.value })} data-testid="txn-journal-ref" /></div>
      <JournalLines clientId={clientId} coa={coa} lines={f.lines} onChange={(lines) => setF((s) => ({ ...s, lines }))} testid="txn-journal" />
      <div className="flex items-center justify-between flex-wrap gap-3">
        <label className="flex items-center gap-2 text-xs text-muted-foreground cursor-pointer">
          <Switch checked={postNow} onCheckedChange={setPostNow} data-testid="txn-journal-post-now" />{fl("postNow", lang)}
        </label>
        <div className="flex gap-2">
          <Button type="button" variant="outline" onClick={onCancel}>{t("common.cancel")}</Button>
          <Button type="button" onClick={save} disabled={!balanced || saving} data-save="" data-testid="txn-journal-save">{t("common.save")}</Button>
        </div>
      </div>
    </div>
  );
}
